import { Badge, Loader } from "@mantine/core";

const TotalCountBadge = ({ filterType, filterItem, countFilterResults }) => {
  if (!countFilterResults) {
    return (
      <Badge color="indigo" variant="light">
        <Loader
          size="sm"
          variant="dots"
          style={{ marginTop: -5, height: 20 }}
        />
      </Badge>
    );
  }

  if (filterType === "popularFilters") {
    return (
      <Badge color="indigo" variant="light">
        {countFilterResults?.popularFilters[filterItem]}
      </Badge>
    );
  }

  if (filterType === "houseType") {
    return (
      <Badge color="indigo" variant="light">
        {countFilterResults?.houseTypes[filterItem]
          ? countFilterResults?.houseTypes[filterItem]
          : 0}
      </Badge>
    );
  }

  return null;
};

export default TotalCountBadge;
